import { useState } from "react";
import { visionURL } from "../../config/environment";
import { isIframed } from "../../utils/iframe";
import { buildCognitoHeaders } from "../../utils/cognitoHeaders";

export const useGoogleMapsApiKey = () => {
  const [isLoading, setIsLoading] = useState(false);
  return {
    getGoogleMapsApiKey: async () => {
      setIsLoading(true);
      const headers = await buildCognitoHeaders({});
      const response = await fetch(`${visionURL}/api/google_maps`, {
        credentials: "include",
        headers
      });

      const unauthorized = response.status === 401;

      if (isIframed && unauthorized) {
        window.parent.postMessage("sessionTimeout", "*");
      }

      const res = await response.json();
      setIsLoading(false);
      return res;
    },
    isLoading
  };
};
